// extracted by mini-css-extract-plugin
export default {"MainContainer":"About_MainContainer__Mzmom","AboutBtn":"About_AboutBtn__4nhPH","ContentHeading":"About_ContentHeading__J-QL2","Content":"About_Content__fuq+b"};